<template>
  <div>
    <!-- <nnav></nnav> -->

    <div
      class="help_box"
      :style="{
        height: MHeight
      }"
    >
      <div class="help_left" style="position: relative;">
        <!-- <div class="block" style="position: absolute;left: 0;top: 80px;">
          <el-slider :step="10" show-stops  v-model="value" vertical height="1200px">
          </el-slider>
        </div> -->
        <div
          style="padding-left: 10px;font-size: 20px;color: #5B85FF;font-weight: 500;cursor: pointer;margin-bottom: 10px;"
          @click="jump2"
        >
          {{ title }}
        </div>
        <a
          v-for="(item, index) in res.data"
          :key="index"
          style="cursor: pointer;display: block;box-sizing: border-box;padding-left: 30px;color: #181E2D;margin-bottom: 15px;font-size: 18px;"
        >
          <div
            :class="{ active_color: active == item.name }"
            @click="jump(item.md, item.name, item)"
            :style="{
              fontSize: '16px',
              padding: ' 3px 0 8px',
              position: 'relative',
              color: item.deleted ? '#5B85FF' : ''
            }"
          >
            {{ item.name }}
          </div>
        </a>
      </div>

      <div class="help_right help-faq-html-root">
        <div style="height: 30px;"></div>
        <div
          :id="title"
          style="font-size: 24px;font-weight: 500;margin-bottom: 20px;"
        >
          {{ title }}
        </div>
        <div style="font-size: 24px;font-weight: 500;margin-bottom: 20px;">
          目录
        </div>

        <!-- <div v-for="(item, index) in res.data" :key="index">
          <h3
            style="font-size: 18px;font-weight: 500;margin-bottom: 20px;color:#5B85FF;display: flex;margin-top: 20px;"
            :id="'a' + item.id"
          >
            <p
              style="width: 3px;height: 16px;background-color: #5B85FF;margin-top: 5px;margin-right: 10px;"
            ></p>
            {{ item.name }}
          </h3>
          <div v-html="item.text"></div>
          <div v-for="(e, i) in item.childs" :key="i">
            <h2
              :id="'a' + e.id"
              style="font-size: 16px;font-weight: 500;margin: 20px 0;color:#5B85FF"
            >
              {{ e.name }}
            </h2>
            <div v-html="e.text"></div>
          </div>
        </div> -->

        <a
          v-for="(item, index) in res.data"
          :key="index"
          style="display: block;box-sizing: border-box;padding-left: 30px;color: #181E2D;margin-bottom: 15px;font-size: 18px;"
        >
          <div
            style="font-size: 16px;"
            v-show="item.deleted"
            :class="{ active_color: active == e.name }"
            v-for="(e, i) in item.childs"
            :key="i"
          >
            <a
              class="hoverA"
              style="font-size: 20px;margin-bottom: 10px;font-weight: 500;display: inline-block;cursor: pointer;color: #5B85FF;"
              @click="stretch(e)"
            >
              <i v-show="e.deleted" class="el-icon-caret-bottom"></i>
              <i v-show="!e.deleted" class="el-icon-caret-top"></i>
              {{ e.name }}
            </a>

            <div
              style="margin-bottom: 20px;margin-left:45px"
              v-show="e.deleted"
              v-html="e.text"
            ></div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import nnav from "../../components/nav/index";
// import './style.css';
import $ from "jquery";
export default {
  components: { nnav },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 54 + "px",
      res: [],
      tr: true,
      childs: [],
      type: "",
      active: "",
      title: "",
      value: 0
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.$axios
      .post("/api/helps", { type: this.type })
      .then(res => {
        console.log(res);
        res.data.data.forEach(item => {
          item.md = "#a" + item.id;

          if (item.childs) {
            item.childs.forEach(e => {
              this.childs.push(e.id);
              e.md = "#a" + e.id;
            });
          }
        });

        this.res = res.data;
        this.jump(res.data.data[0].md, res.data.data[0].name, res.data.data[0]);

        this.$nextTick(() => {
          this.fixHelpImages();
          //带参数进网页
          setTimeout(() => {
            this.res.data.forEach(item => {
              console.log(item.name, 666);
              if (this.$route.query.name == item.name) {
                if (this.$route.query.name == item.name) {
                  this.jump(item.md, item.name, item);
                }
              }

              if (item.childs) {
                item.childs.forEach(e => {
                  this.childs.push(e.id);
                  e.md = "#a" + e.id;

                  if (this.$route.query.name == e.name) {
                    this.jump(e.md, e.name, e);
                  }
                });
              }
            });
          }, 0);
        });
      })

      .catch(err => {
        // console.log(err);
      });
  },
  methods: {
    /** 仅处理帮助文档 v-html 内的相对路径图片，避免影响全站其它 p img */
    jump(id, name, e) {
      this.res.data.forEach(item => {
        if (item.id == e.id) {
          item.deleted = true;
        } else {
          item.deleted = false;
        }
      });
      //   e.deleted = true;
      console.log(e);
      //   e.deleted = !e.deleted;
      //   document.querySelector(id).scrollIntoView(true);
      //   this.active = name;
      //querySelector可以获取dom元素，括号内为css属性选择器；
      // console.log(e);
    },
    stretch(e) {
      e.deleted = !e.deleted;
      console.log(e);
    },
    jump1(id) {
      document.querySelector(id).scrollIntoView(true);
    },
    jump2() {
      var title = "#" + this.title;
      document.querySelector(title).scrollIntoView(true);
      // console.log(title);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    fixHelpImages() {
      const root = this.$el && this.$el.querySelector('.help-faq-html-root');
      if (!root) return;
      const base = 'https://yunsrvwebapi.jeesit.com';
      root.querySelectorAll('img').forEach((img) => {
        const src = img.getAttribute('src');
        if (!src || /^https?:\/\//i.test(src) || src.indexOf(base) === 0) {
          return;
        }
        img.src = base + src;
      });
    }
  },
  watch: {
    type() {
      if (this.type == "4") {
        this.title = "交易端手册";
      }
      if (this.type == "5") {
        this.title = "多账户交易端手册";
      }
    }
  }
};
</script>
<style>
.el-menu {
  border-right: 0 !important;
}
.el-submenu .el-menu-item {
  height: 28px;
  line-height: 28px;
}
.el-menu-item,
.el-submenu__title {
  height: 28px;
  line-height: 28px;
}
.el-menu-item-group__title {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/help2/index.vue